import React from 'react';
import TitleWrapper from 'components/organisms/home/TitleWrapper';
import Welcome from 'components/organisms/home/Welcome';
import LandingBackground from 'assets/admin_landing_splash.png';

const AdminTitle = () => (
    <TitleWrapper background={LandingBackground} backgroundColor='#007CC4'>
        <Welcome color='#fff'>Admin Home</Welcome>
    </TitleWrapper>

);

export default AdminTitle;



// WEBPACK FOOTER //
// ./src/components/molecules/home/AdminTitle.js